import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function ArrowBackIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M3.00966 12.1913H21M10.2142 5L3.00005 12.2154L10.2142 19.4307"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
